/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

export const SummaryTemplate = (documentTitle: string, includeSelectionSummary: boolean) => `
  <h3>${documentTitle}</h3>
  ${
    includeSelectionSummary
      ? `
        {{selectionSummary}}
        `
      : ''
  }
  <h3>Labs</h3>
  {{labsDoneSummary}}
  <br/><br/>
  {{labsNotDoneSummary}}
  <br/><br/>
  <h3>Imaging</h3>
  {{imagingDoneSummary}}
  <br/><br/>
  {{imagingNotDoneSummary}}
  <br/><br/>
  <h3>Procedures</h3>
  {{proceduresDoneSummary}}
  <br/><br/>
  {{proceduresNotDoneSummary}}
`;
